
const ms_MY = {
  "产品菜单": "Produk",
  "关于我们菜单": "Tentang Kami",
  "帮助中心菜单": "Pusat Bantuan",
  "信用基础": "Berdasarkan Kredit",
  "加密支付": "Pembayaran Terenkripsi",
  "全币种支持": "Sokongan Semua Mata Wang",
  "全节点承兑": "Penerimaan Node Penuh",
  "去中心担保": "Jaminan Terdesentralisasi",
  "立即开始使用": "Mula Sekarang",
  "闪电般的支付体验": "Pengalaman Pembayaran Sepantas Kilat",
  "完成跨境支付": "Selesaikan Pembayaran Rentas Sempadan dalam 45 Saat",
  "多链支持": "Sokongan Multi-Rantai",
  "支持主流公链资产": "Menyokong Aset Rantai Awam Utama",
  "实时结算": "Penyelesaian Masa Nyata",
  "无需等待": "Tiba dalam Saat, Tidak Perlu Menunggu",
  "超额担保": "Jaminan Berlebihan",
  "资金安全有保障": "Keselamatan Dana Terjamin",
  "一个钱包": "Satu Dompet",
  "所有可能": "Semua Kemungkinan",
  "商户收款": "Kutipan Pedagang",
  "全球化支付网关": "Gerbang Pembayaran Global",
  "承兑服务": "Perkhidmatan Penerimaan",
  "稳定可靠的承兑网络": "Rangkaian Penerimaan yang Stabil dan Boleh Dipercayai",
  "数字资产": "Aset Digital",
  "多链资产管理": "Pengurusan Aset Multi-Rantai",
  "下载": "Muat Turun App",
  "多节点承兑": "Penerimaan Multi-Node",
  "生态": "Ekosistem NECO",
  "钱包": "TEPAY Wallet",
  "立即下载": "Muat Turun Sekarang",
  "随时汇币": "Bayar dengan Mata Wang Kripto di Mana Sahaja, Penghantaran Wang Antarabangsa Tidak Lagi Sukar",
  "走天下": "Jelajahi Dunia",
  "海量订单": "Jumlah Pesanan yang Besar",
  "日进斗金": "Pendapatan Harian yang Besar",
  "首页描述": "TePay adalah infrastruktur pembayaran kredit terdesentralisasi, bukan bank. Perkhidmatan kewangan disokong oleh rangkaian nod penerima kami dan rangkaian kontrak pintar berasaskan blockchain. Mekanisme cagaran dan kredit memastikan transaksi yang selamat dan mematuhi peraturan, manakala eskrow dan penyelesaian pertikaian diuruskan melalui sistem timbang tara DAO kami. Kebolehoperasian pelbagai rantaian dan modul pematuhan bersepadu menyediakan pengalaman pembayaran yang lancar dan telus untuk kedua-dua pengguna dan peniaga.",
  "轻松交易": "Urus Niaga Mudah",
  "slide2Text": "Mencapai pertukaran yang bebas dan lancar antara mata wang fiat dan digital melalui rangkaian multi-node terdesentralisasi TePay",
  "slide2Info": "TePay adalah platform pembayaran terdesentralisasi, bukan bank tradisional. Perkhidmatan disediakan oleh rangkaian penerima multi-node kami dan dijamin oleh kontrak pintar blockchain. Mekanisme cagaran berlebihan dan penilaian kredit memastikan setiap transaksi mematuhi peraturan dan selamat.",
  "全球通用": "Global",
  "让每一笔支付": "Jadikan Setiap Pembayaran",
  "瞬间达成": "Selesai serta-merta",
  "slide3Text": "Urus niaga bebas mata wang fiat dan digital dalam rangkaian TePay yang kuat",
  "slide3Info": "TePay tidak terhad kepada satu mata wang. Platform terdesentralisasi kami membolehkan anda menghantar, menerima dan menukar pelbagai mata wang dengan mudah, memecahkan sempadan negara dan menikmati pengalaman yang bersatu. Dengan teknologi blockchain dan mekanisme kredit dinamik, dana anda sentiasa beroperasi dengan selamat dan cekap.",
  "护航每笔交易": "Mengawal Setiap Urus Niaga",
  "去中心化担保": "Jaminan Terdesentralisasi",
  "安全无忧": "Selamat dan Tenang",
  "slide4Text": "Menyediakan jaminan kepercayaan dan sokongan keselamatan untuk setiap transaksi melalui mekanisme jaminan terdesentralisasi",
  "slide4Info": "TePay bukan bank tradisional, tetapi memastikan keselamatan transaksi melalui mekanisme jaminan terdesentralisasi. Sistem kami menggunakan cagaran berlebihan, penilaian kredit dinamik dan timbang tara DAO untuk memberikan jaminan yang kukuh untuk setiap transaksi. Mekanisme jaminan yang kuat ini menghubungkan kewangan tradisional dan aset digital dengan berkesan, memastikan semua pembayaran mematuhi peraturan, selamat dan cekap.",
  "一个钱包走天下": "Satu Dompet untuk Jelajah Dunia",
  "币随时付": "Mata Wang Kripto Boleh Dibayar Bila-bila Masa",
  "跨境无忧": "Tanpa Risiko Rentas Sempadan",
  "slide5Text": "Urus semua aset dalam satu tempat, sama ada mata wang fiat atau digital, dalam satu dompet yang selamat",
  "slide5Info": "TePay menyatukan dunia kewangan anda, menyelesaikan semua keperluan pembayaran dengan satu dompet. Platform kami menggabungkan pengurusan aset dan urus niaga global, bergantung pada teknologi blockchain maju dan mekanisme kredit dinamik untuk memberikan pengalaman kewangan yang lancar dan cekap.",
  "slide6Text": "Memenuhi keperluan pelbagai mata wang peniaga dan pelanggan, meraih keuntungan tanpa had",
  "slide6Info": "Enjin padanan dinamik TePay meruntuhkan halangan antara mata wang fiat dan digital, membolehkan nod penerima mendapat keuntungan tanpa mengira mata wang yang digunakan oleh peniaga atau pelanggan. Platform menyelesaikan dengan cekap, setiap transaksi membantu anda menggandakan pendapatan.",
  "边兑边赚": "Tukar Sambil Hasilkan",
  "信用随行": "Kredit Mengiringi",
  "slide7Text": "Setiap pertukaran menggandakan pendapatan anda, sementara kredit meningkat secara berterusan",
  "slide7Info": "TePay bukan bank tradisional, tetapi memastikan keselamatan transaksi melalui mekanisme jaminan terdesentralisasi. Sistem kami menggunakan cagaran berlebihan, penilaian kredit dinamik dan timbang tara DAO untuk memberikan jaminan yang kukuh untuk setiap transaksi. Mekanisme jaminan yang kuat ini menghubungkan kewangan tradisional dan aset digital dengan berkesan, memastikan semua pembayaran mematuhi peraturan, selamat dan cekap.",
  "下载TEPAY": "Muat Turun TEPAY",
  "开启信用支付": "Mulakan Pembayaran Kredit",
  "多币种支持": "Sokongan Pelbagai Mata Wang",
  "多节点承兑描述": "Penerimaan Multi-Node",
  "下载Text": "Muat Turun",
  "链上赋能": "Pemberdayaan On-Chain E-dagang Komuniti",
  "品牌即社区": "Jenama sebagai Komuniti",
  "消费即投资": "Konsumsi sebagai Pelaburan",
  "本地即全球": "Tempatan sebagai Global",
  "首页描述": "Platform E-dagang Komuniti NECO (Laike) menggunakan rangka kerja kepercayaan terdesentralisasi Web3 sebagai asas, menggabungkan penggunaan sebenar dengan pulangan telus on-chain, membentuk semula kitaran nilai pengguna, peniaga dan komuniti, dan mencipta paradigma e-dagang baru yang boleh dikongsi, dipercayai dan mampan.",
  "真实消费": "Konsumsi Sebenar",
  "支撑返利": "Menyokong Pulangan",
  "slide2Text": "Lebih Banyak Beli, Lebih Banyak Pulangan Sebenar",
  "slide2Info": "NECO hanya menjana bon dan mata yang sepadan selepas pesanan selesai dan disahkan on-chain; jumlah pulangan dipautkan ketat kepada diskaun 20% peniaga, tanpa sebarang terbitan berlebihan. Ini bermakna semua ganjaran platform dibayar oleh aliran tunai sebenar, setiap NECO/USAI yang dilihat oleh pengguna boleh dikesan dalam penerokah blok, mengasingkan sepenuhnya risiko 'skim wang'.",
  "透明积分": "Mata Telus",
  "代币经济": "Ekonomi Token",
  "slide3Text": "Mata On-Chain, Nilai Boleh Disahkan",
  "slide3Info1": "Pulangan penggunaan dibahagikan kepada dua lejar: token platform NECO dan stablecoin USAI",
  "slide3Info2": "Bekas dibebaskan secara linear 0.2% setiap hari, yang latter mengimbangi kadar pertukaran secara automatik dengan pembakaran/penempaan",
  "slide3Info3": "Semua acara penempaan, pembakaran dan pembebasan direkodkan oleh kontrak pintar, sesiapa sahaja boleh melihat baki dompet, masa pembebasan dan sejarah transaksi secara masa nyata, memberikan setiap insentif 'kad pengenalan' awam.",
  "多角色": "Pelbagai Peranan",
  "激励生态": "Ekosistem Insentif",
  "slide4Text1": "Pengguna, Ketua, Peniaga, Kitaran Menang-Menang",
  "slide4Info1": "Pengguna: Pulangan 100% mata untuk penggunaan, pegang NECO untuk menikmati kenaikan nilai dan hak tadbir urus",
  "slide4Info2": "Ketua: Atur pembelian berkumpulan, urus komuniti, dapatkan komisen + ganjaran tambahan NECO",
  "slide4Info3": "Peniaga: Tukar diskaun dengan pesanan tepat, nikmati penyelesaian 0 yuran dan pendedahan jenama",
  "slide4Info4": "Pendapatan tiga pihak ditulis dalam formula on-chain yang sama, pendapatan dan perbelanjaan diselaraskan secara masa nyata, membentuk kitaran pembelahan berpacu sendiri",
  "合规保障": "Jaminan Pematuhan",
  "全程可审": "Boleh Diaudit Sepenuhnya",
  "slide5Text": "Jejak On-Chain, Mesra Pengawal Selia",
  "slide5Info1": "Gerbang TePay mengendalikan KYC, sambungan mata wang fiat dan pematuhan pembayaran; data transaksi, perkadaran diskaun, pengagihan mata semua disimpan on-chain",
  "slide5Info2": "Platform juga menetapkan oracle berganda, penampan harga dan dana kawalan risiko DAO, apabila terdapat keadaan pasaran melampau atau perubahan dasar, mekanisme had laju, beli balik atau jeda boleh dicetuskan melalui undi tadbir urus - menjadikan pengawal selia tenang, pengguna tenang, ekosistem berkembang maju.",
  "合作伙伴": "Rakan Kongsi",
  "社区团购": "Pembelian Berkumpulan Komuniti",
  "社区小店": "Kedai Kecil Komuniti",
  "社区空间": "Ruang Komuniti",
  "社区服务": "Perkhidmatan Komuniti",
  "NECO优选": "Pilihan NECO",
  "暂未开放": "Belum Dibuka Buat Sementara",
  "新闻标题": "Pusat Berita",
  "新闻1标题": "Pengumuman Masa Pelancaran Genesis, Pelancaran APP dan Pembukaan Sistem Keahlian",
  "新闻1内容": "Kepada semua ahli komuniti:\n\nKami menjangka untuk membuka pasangan dagangan NECO/nUSDT, USAI/nUSDT di Novai SWAP pada 5 Ogos 24:00 (GMT+8), melengkapkan pelancaran genesis token platform dan stablecoin.\n\nPada masa yang sama, APP NECO akan membuka pendaftaran secara rasmi dan melancarkan sistem keahlian global, anda boleh melakukan operasi berikut dalam sistem ini:\n1. Pendaftaran pengguna dan perkongsian pautan\n2. Isi USDT ke akaun pra-bayar untuk menjadi USAI, dan beli keahlian VIP\n3. Pembebasan mata sama nilai untuk nod genesis dan nod biasa (dapatkan pendapatan NECO)\n4. Dapatkan rujukan ahli dan ganjaran mata pasukan, urus pasukan sendiri\n5. Pembebasan mata penggunaan (pembelian keahlian, ganjaran pasukan dan ganjaran nod) kepada NECO\n6. Pertukaran serta-merta NECO kepada USAI dan pengeluaran (versi semasa menyokong pengeluaran sebagai USDT)\n7. Fungsi asas pulangan saham penggunaan (lihat harga NECO, lihat pasangan dagangan SWAP NECO, lihat pengumuman, dll.)\n\nSekiranya terdapat pelarasan masa, kami akan mengumumkan secara berasingan.",
  "返回": "Kembali",
  "消费返股": "Pulangan Saham Penggunaan E-dagang Komuniti",
  "全球首个": "Pertama di Dunia",
  "WEB3社区电商平台": "Platform E-dagang Komuniti WEB3",
  "消费": "Konsumsi",
  "赚钱": "Hasilkan Wang",
  "持股": "Pegangan Saham",
  "合伙人": "Rakan Kongsi",
  "用户": "Pengguna",
  "股东": "Pemegang Saham",
  "不只是电商": "NECO Bukan Hanya E-dagang",
  "更是社区电商": "Tetapi Juga E-dagang Komuniti",
  "共赢闭环": "Pengguna, Ketua, Peniaga, Kitaran Menang-Menang",
  "用户描述": "Pengguna: Pulangan 100% mata untuk penggunaan, pegang NECO untuk menikmati kenaikan nilai dan hak tadbir urus",
  "团长描述": "Ketua: Atur pembelian berkumpulan, urus komuniti, dapatkan komisen + ganjaran tambahan NECO",
  "商户描述": "Peniaga: Tukar diskaun dengan pesanan tepat, nikmati penyelesaian 0 yuran dan pendedahan jenama",
  "三方描述": "Pendapatan tiga pihak ditulis dalam formula on-chain yang sama, pendapatan dan perbelanjaan diselaraskan secara masa nyata, membentuk kitaran pembelahan berpacu sendiri",
  "购物聊天": "E-dagang AI NECO, Jadikan Membeli-belah Semudah Berbual",
  "边聊边选": "Berbual Sambil Pilih",
  "聊天助手实时理解你的对话": "Pembantu bualan AI memahami perbualan anda secara masa nyata",
  "就能找到你要的东西": "Satu perkataan, anda boleh jumpa apa yang anda mahu",
  "AI优选": "Pilihan AI",
  "的那一刻": "Saat anda buka NECO",
  "已经在等你": "Barang dan perkhidmatan yang paling sesuai untuk anda, sudah menunggu",
  "时尚分身": "Avatar Fesyen",
  "监控价格": "Cari barang baik, pantau harga",
  "守护你的消费体验": "Jaga pengalaman penggunaan anda",
  "三类团购机制": "Mekanisme Pembelian Berkumpulan Tiga Jenis",
  "附近团": "Kumpulan Berdekatan",
  "熟人团": "Kumpulan Kenalan",
  "优选团": "Kumpulan Pilihan",
  "全球战略布局": "Susun Strategi Global",
  "使命与愿景": "Misi dan Visi NECO",
  "使命": "Misi",
  "愿景": "Visi",
  "使命描述": "Wujudkan sistem perniagaan pengorganisasian sendiri yang adil, telus dan boleh disertai",
  "愿景描述": "Hidupkan cahaya ekonomi komuniti di setiap penjuru dunia",
  "公告": "Pengumuman",
  "铸造销毁协议": "Protokol Penempaan dan Pembakaran",
  "SWAP交易": "Dagangan SWAP",
  "NECO社区电商": "E-dagang Komuniti NECO",
  "菜单": "Menu",
  "安卓下载": "Muat Turun Android",
  "ios下载": "Muat Turun iOS",
  "NECO下载": "Muat Turun App NECO",
  "支持版本": "Sokongan Versi iOS Android",
  "当前版本": "Versi Semasa",
  "跨链桥": "Jambatan Rentas Rantai",
  "合作伙伴关系": "Perkongsian strategik",
  "请加入社交媒体信息": "Sila Sertai Maklumat Media Sosial",
  "联系我们": "Hubungi Kami",
  "版权所有（公司）": "Hak Cipta (Syarikat)",
  "联系我们的邮件请填写": "Sila isi e-mel kami",
  "新闻": "Akhbar",
  "网页直连": "Pautan Langsung",
  "铸造与销毁协议": "Perjanjian pengecoran dan pemusnahan",
  "更多": "Lebih lanjut",
  "请通过": "Sila lalui",
  "与我们联系": "Hubungi Kami",
  "版权所有": "Hak cipta terpelihara",
  "联系": "Hubungi",
  "智能体": "sembang bot",

  
  "全球首个": "Global yang pertama",
  "WEB3社区电商平台": "Platform e-dagang komuniti WEB3",
  "消费": "Penggunaan",
  "持股": "Kepemilikan saham",
  "升值": "Naik nilai",
  "重新定义消费的价值": "Mentakrif semula nilai penggunaan",
  "让消费成为财富的起点": "Jadikan penggunaan sebagai titik permulaan kekayaan",
  "消费即拥有，分享即收益": "Gunakan = Miliki, Kongsi = Dapat keuntungan",
  "NECO 是一套基于 Web3 技术的智能电商基础设施，通过「消费即持股」机制，让每一位用户在购物时获得真实权益与长期回报。 在这里，消费者不只是用户，更是平台的拥有者和生态的建设者。": "NECO ialah infrastruktur e-dagang pintar berdasarkan teknologi Web3, melalui mekanisme \"penggunaan adalah kepemilikan saham\", membolehkan setiap pengguna memperoleh hak sebenar dan pulangan jangka panjang semasa membeli-belah. Di sini, pengguna bukan sahaja pengguna, tetapi juga pemilik platform dan pembina ekosistem.",
  "核心技术": "Teknologi teras",
  "基于 Novai Chain 的二层网络": "Rangkaian lapisan dua berdasarkan Novai Chain",
  "Neco Chain 是构建在 Novai Chain 之上的高性能二层网络，": "Neco Chain ialah rangkaian lapisan dua berprestasi tinggi yang dibina di atas Novai Chain,",
  "专为高频电商与支付结算设计，平均出块时间仅 0.2 秒，TPS 超过 50,000。": "Direka khas untuk e-dagang berfrekuensi tinggi dan penyelesaian pembayaran, masa blok purata hanya 0.2 saat, TPS melebihi 50,000.",
  "Neco Chain 将电商的每笔消费行为与激励记录上链，": "Neco Chain merekodkan setiap tingkah laku penggunaan dan insentif e-dagang ke dalam rantaian,",
  "让商业行为具备长期可验证性与可追溯性。": "Menjadikan tingkah laku perniagaan mempunyai kebolehkesahan dan kebolehkesan penjejakan jangka panjang.",
  "高速并行账本结构": "Struktur lejar selari berkelajuan tinggi",
  "智能结算与动态费用调节": "Penyelesaian pintar dan pelarasan yuran dinamik",
  "消费凭证 NFT 化与积分资产化": "Pengesahan penggunaan menjadi NFT dan mata ganjaran menjadi aset",
  "核心特性": "Ciri teras",
  "链上结算": "Penyelesaian atas rantaian",
  "每笔电商交易 0.2 秒确认，安全透明": "Setiap transaksi e-dagang disahkan dalam 0.2 saat, selamat dan telus",
  "激励协议": "Protokol insentif",
  "激励消费者、商家、渠道等为NECO做出贡献": "Menggalakkan pengguna, peniaga, saluran dan lain-lain menyumbang kepada NECO",
  "权益积分": "Mata ganjaran hak",
  "用户消费即持有可追踪、可变现的权益积分": "Pengguna menggunakan sama ada memegang mata ganjaran hak yang boleh dijejaki dan ditukar nilai",
  "共建共享": "Bina bersama kongsi bersama",
  "首个去中心商业自治组织，共建共享NECO电商": "Organisasi autonomi perniagaan terdesentralisasi pertama, bina dan kongsi e-dagang NECO bersama",
  "主要产品": "Produk utama",
  "支持电商 RWA 的高性能公链": "Rantaian awam berprestasi tinggi menyokong RWA e-dagang",
  "稳定币、DEX、去中心信用等电商基础协议": "Stablecoin, DEX, kredit terdesentralisasi dan protokol asas e-dagang lainnya",
  "同时为WEB2和WEB3用户服务的电商APP": "Aplikasi e-dagang yang melayani pengguna WEB2 dan WEB3 serentak",
  "法币和数字货币统一支付及结算体系": "Sistem pembayaran dan penyelesaian kesatuan mata wang fiat dan mata wang digital",
  "竞争优势": "Kelebihan persaingan",
  "极速公链": "Rantaian awam kelajuan ultra",
  "0.2 秒出块，支持百万级并发订单及支付交易。": "0.2 saat menghasilkan blok, menyokong pesanan dan transaksi pembayaran serentak berjuta-juta.",
  "全球合规": "Kepatuhan global",
  "在全球各地通过 DAO 组织进行本地合规运营。": "Menjalankan operasi patuh tempatan melalui organisasi DAO di seluruh dunia.",
  "电商 RWA": "RWA e-dagang",
  "第一个将现实世界电商完全放在链上运行的平台。": "Platform pertama yang meletakkan e-dagang dunia sebenar sepenuhnya berjalan di atas rantaian.",
  "商业闭环": "Gelung tertutup perniagaan",
  "让消费、社交与收益形成价值闭环。": "Menjadikan penggunaan, sosial dan keuntungan membentuk gelung nilai.",
  "全球分销体系让每个用户都能成为品牌的传播者与收益方。": "Sistem pengedaran global membolehkan setiap pengguna menjadi penyebar jenama dan pihak yang mendapat keuntungan.",
  "消费者端": "Bahagian pengguna",
  "注册/消费即得积分奖励，积分每日释放为资产。": "Daftar/gunakan terus dapat ganjaran mata ganjaran, mata ganjaran dilepaskan sebagai aset setiap hari.",
  "商家端": "Bahagian peniaga",
  "一键接入结算 API，设置折让比例与积分政策。": "Sambung API penyelesaian dengan satu klik, tetapkan nisbah diskaun dan dasar mata ganjaran.",
  "分销端": "Bahagian pengedaran",
  "允许全球用户参与分销，共享收益与品牌成长。": "Membenarkan pengguna global menyertai pengedaran, berkongsi keuntungan dan pertumbuhan jenama.",
  "NECO 生态系统": "Ekosistem NECO",
  "一个融合金融、科技与商业的去中心化生态。": "Ekosistem terdesentralisasi yang menggabungkan kewangan, teknologi dan perniagaan.",
  "Neco Chain 公链": "Rantaian awam Neco Chain",
  "商业级高速 Layer 2 网络（Novai L2），提供结算与数据验证基础设施。": "Rangkaian Layer 2 berkelajuan tinggi tahap perniagaan (Novai L2), menyediakan infrastruktur penyelesaian dan pengesahan data.",
  "NECO App": "Aplikasi NECO",
  "用户购物、签到、邀请与分销的统一入口。": "Titik masuk kesatuan untuk membeli-belah, daftar hadir, jemput dan edar pengguna.",
  "USAI 稳定币": "Stablecoin USAI",
  "用于平台内支付与结算的稳定币资产，锚定美元价值。": "Aset stablecoin digunakan untuk pembayaran dan penyelesaian dalam platform, diikat kepada nilai dolar AS.",
  "U Card 全球消费卡": "Kad penggunaan global U Card",
  "连接线上线下消费场景，支持积分抵扣与现金返还。": "Menghubungkan senario penggunaan dalam talian dan luar talian, menyokong potongan mata ganjaran dan pemulangan tunai.",
  "NECO AI 智能系统": "Sistem pintar NECO AI",
  "通过 AI 分析用户行为，实现个性化推荐与安全风控。": "Melalui AI menganalisis tingkah laku pengguna, melaksanakan cadangan peribadi dan kawalan risiko keselamatan.",
  "消费金融该协议": "Protokol kewangan penggunaan",
  "提供通用的去中心化金融基础设施，支持电商资产流通。": "Menyediakan infrastruktur kewangan terdesentralisasi universal, menyokong peredaran aset e-dagang.",
  "稳定币生态": "Ekosistem stablecoin",
  "构建覆盖支付、结算与跨境流通的稳定币网络。": "Membina rangkaian stablecoin yang merangkumi pembayaran, penyelesaian dan peredaran merentas sempadan.",
  "团队及投资人": "Pasukan dan pelabur",
  "全球化视野 · 多元化背景。": "Pandangan global · Latar belakang pelbagai.",
  "NECO 团队成员来自新加坡、中国、阿联酋等地，拥有电商、金融科技与区块链技术领域超过十年的行业经验。": "Ahli pasukan NECO berasal dari Singapura, China, UAE dan tempat lain, mempunyai lebih daripada sepuluh tahun pengalaman industri dalam bidang e-dagang, teknologi kewangan dan teknologi blockchain.",
  "投资人": "Pelabur",
  "运营团队": "Pasukan operasi",
  "Moe Farmani": "Moe Farmani",
  "拥有多年欧洲、中东、南美零售企业创业经验,曾创建迪拜领先的数字货币交易所 加密货币的重度信仰者": "Mempunyai bertahun-tahun pengalaman memulakan perniagaan e-dagang Eropah, Timur Tengah, Amerika Selatan, pernah menubuhkan bursa mata wang digital terkemuka Dubai, penganut teguh mata wang kripto",
  "Matt Romman": "Matt Romman",
  "从事迪拜房地产和零售行业多年。拥有丰富的跨国公司管理经验。": "Bertahun-tahun terlibat dalam industri hartanah dan e-dagang Dubai. Mempunyai pengalaman pengurusan syarikat multinasional yang kaya.",
  "Alex Eric": "Alex Eric",
  "曾任职OKX，负责公司品牌和战略": "Pernah bertugas di OKX, bertanggungjawab atas jenama dan strategi syarikat",
  "Manoharlal": "Manoharlal",
  "Novai Chain Founder， 全面支撑NECO技术落地。": "Pengasas Novai Chain, menyokong sepenuhnya pelaksanaan teknologi NECO.",
  "官方路线图": "Peta jalan rasmi",
  "2025 — 创世与启动": "2025 — Genesis dan Pelancaran",
  "2025 — 增长与市场拓展": "2025 — Pertumbuhan dan Pengembangan Pasaran",
  "2026 — 生态深化与 AI 赋能": "2026 — Pemendalam Ekosistem dan Pemberian Kuasa AI",
  "上半年（Q2–Q3）": "Separuh pertama tahun (Q2–Q3)",
  "完成白皮书、制度模型与产品原型开发": "Menyelesaikan pembangunan kertas putih, model sistem dan prototaip produk",
  "组织九大社区进行创世启动": "Menganjurkan sembilan komuniti untuk melancarkan genesis",
  "完成 300 个节点招募，发行 NECO & USAI 代币，添加初始流动性池": "Menyelesaikan perekrutan 300 nod, mengeluarkan token NECO & USAI, menambah kumpulan kecairan awal",
  "发布 NECO APP BETA 测试版": "Menerbitkan versi ujian BETA Aplikasi NECO",
  "下半年（Q3–Q4）": "Separuh akhir tahun (Q3–Q4)",
  "全球社区运营中心部署完成": "Penyiaran Pusat Operasi Komuniti Global selesai",
  "NECO 优选店铺与创世商户上线": "Kedai pilihan NECO dan peniaga genesis dilancarkan",
  "推动注册用户突破 10 万": "Mendorong pengguna berdaftar mencecah 100,000",
  "启动空投及全球电商启动大会": "Melancarkan airdrop dan persidangan pelancaran e-dagang global",
  "Q4：好货推广 & 本地电商": "Q4: Promosi barangan bagus & e-dagang tempatan",
  "上线「好货系统」并开放会员商家入驻": "Melancarkan \"sistem barangan bagus\" dan membuka pendaftaran peniaga ahli",
  "在主要国家开通 TePay 法币支付": "Membuka pembayaran mata wang fiat TePay di negara utama",
  "完成中国、韩国、越南 10 家 NECO Best 本地电商落地": "Menyelesaikan penempatan 10 e-dagang tempatan NECO Best di China, Korea, Vietnam",
  "海外注册用户突破 50 万，VIP 用户突破 5 万": "Pengguna berdaftar luar negeri mencecah 500,000, pengguna VIP mencecah 50,000",
  "举办第二次社区电商大会，开放跨境卖家注册": "Menganjurkan persidangan e-dagang komuniti kedua, membuka pendaftaran penjual merentas sempadan",
  "拓展中东、南美、非洲与欧洲本地市场，整合供应链": "Mengembangkan pasaran tempatan Timur Tengah, Amerika Selatan, Afrika dan Eropah, mengintegrasikan rantaian bekalan",
  "注册用户突破 100 万，VIP 用户突破 10 万": "Pengguna berdaftar mencecah 1 juta, pengguna VIP mencecah 100,000",
  "Q1–Q2：体系完善": "Q1–Q2: Penyempurnaan sistem",
  "跨境卖家突破 10 万，商家数量超 10 万": "Penjual merentas sempadan mencecah 100,000, jumlah peniaga melebihi 100,000",
  "举办第一届 NECO 电商生态大会": "Menganjurkan persidangan ekosistem e-dagang NECO pertama",
  "上线稳定币生态与信用体系": "Melancarkan ekosistem stablecoin dan sistem kredit",
  "注册用户突破 500 万，VIP 超过 20 万": "Pengguna berdaftar mencecah 5 juta, VIP melebihi 200,000",
  "Q3–Q4：智能升级": "Q3–Q4: Naik taraf pintar",
  "获得主要国家支付牌照，全面上线法币支付服务": "Memperoleh lesen pembayaran negara utama, melancarkan sepenuhnya perkhidmatan pembayaran mata wang fiat",
  "上线 AI 选品与推荐功能": "Melancarkan fungsi pemilihan dan cadangan AI",
  "商家信用、积分全面上链": "Kredit peniaga, mata ganjaran sepenuhnya di atas rantaian",
  "NECO Best 优选商家突破 100 家": "Peniaga pilihan NECO Best mencecah 100",
  "注册用户突破 1000 万，VIP 超过 50 万": "Pengguna berdaftar mencecah 10 juta, VIP melebihi 500,000",
  "加入 NECO": "Sertai NECO",
  "消费创造财富，社区共建共享。": "Penggunaan mencipta kekayaan, komuniti membina dan berkongsi bersama.",
  "一分钟带你了解NECO": "Membawa anda mengenali NECO dalam satu minit",
  "NECO 通过链上透明的返利机制，让每一次消费都能获得真实收益。": "NECO memberikan manfaat sebenar untuk setiap penggunaan melalui mekanisme pengembalian keuntungan yang telus di rantaian.",
  "相比传统电商，NECO 的利润由智能合约按比例即时返还，0 抽佣、0 压货。": "Berbanding dengan e-dagang tradisional, keuntungan NECO dikembalikan secara segera oleh kontrak pintar secara proporsional, 0 komisen pengeluaran, 0 barangan tekanan. ",
  "用户与商家共享增长红利。": "Pengguna berkongsi bonus pertumbuhan dengan pedagang.",
  "全球版": "Versi global",
  "中国版": "Versi untuk Cina",

}
export default ms_MY




// WEBPACK FOOTER //
// ./src/i18n/config/ms_MY.js